import type { IconSvgObject } from './types';

const LockSync01Icon: IconSvgObject = [
  ["path", { d: "M21.2154 16.0002C19.6684 19.532 16.1355 22.0002 12.0247 22.0002C6.48823 22.0002 2 17.5231 2 12.0002C2 6.47738 6.48823 2.00023 12.0247 2.00023C17.2229 2.00023 21.497 5.94691 22 11.0002L19.5 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10 11H8.5V16.5H15.5V11H14M10 11V9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5V11M10 11H14", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LockSync01Icon;
